import { AlertService } from '@/common/services/alert/alert.service';
import { CurrentReservationService } from '@/common/services/reservation/current';
import { UrlService } from '@/common/services/url/url.service';
import { isValid } from '@/common/utils/validation/common.utils';
import {
    BranchInt,
    BranchIntParams,
} from '@/core/domain/branches-international/models/branch-international.model';
import { GetAvailabilityInternationalUseCase } from '@/core/domain/branches-international/usecases/getAvailabilityInternational.usecase';
import { SaveReservationUseCase } from '@/core/domain/reservation/usecases/saveReservation.usecase';
import { UpdateReservationUseCase } from '@/core/domain/reservation/usecases/updateReservation.usecase';
import { selectLocationInt } from '@/core/international/store/international.selector';
import { saveVehicles } from '@/core/reservation/store/vehicles.actions';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import _ from 'lodash';
import { catchError, first, throwError } from 'rxjs';

@Component({
    selector: 'fe-card-location',
    templateUrl: './card-location.component.html',
    styleUrls: ['./card-location.component.scss'],
})
export class CardLocationComponent {
    @Input() location!: BranchInt;
    @Input() index: number | undefined;
    paramsServices: unknown;

    public loadingSelectBranch = false;

    constructor(
        private store: Store,
        private readonly router: Router,
        private updateReservation: UpdateReservationUseCase,
        private reservation: CurrentReservationService,
        private readonly getAvailabilityInternational: GetAvailabilityInternationalUseCase,
        private readonly saveReservationUseCase: SaveReservationUseCase,
        private readonly alert: AlertService,
        private readonly url: UrlService,
    ) {}

    getFormattedAddress(): string {
        if (this.location && this.location.address) {
            const {
                streetAddresses,
                city,
                countrySubdivisionCode,
                postalCode,
            } = this.location.address;
            const streetAddress = streetAddresses[1] ? streetAddresses[1] : '';
            return `${streetAddress} ${city} ${countrySubdivisionCode} ${postalCode}`;
        }
        return '';
    }

    clickMark() {
        this.loadingSelectBranch = true;
        const id = this.location.id;

        this.store
            .select(selectLocationInt)
            .pipe(first())
            .subscribe((response) => {
                this.paramsServices = response;

                const locationInt: BranchIntParams = {
                    id: this.location.stationId,
                    location: response.location,
                    fRenta: response.fRenta,
                    hRenta: response.hRenta,
                    fDevolucion: response.fDevolucion,
                    hDevolucion: response.hDevolucion,
                    type: this.location.locationType.toLowerCase(),
                };

                if (isValid(this.reservation.current.age)) {
                    locationInt.age = this.reservation.current
                        .age as unknown as string;
                }

                this.getAvailabilityInternational
                    .execute(locationInt)
                    .pipe(
                        catchError((error) => {
                            this.loadingSelectBranch = false;
                            this.alert.openDefault(error);
                            return throwError(() => error);
                        }),
                    )
                    .subscribe((locations) => {
                        this.updateReservation
                            .execute({
                                locationSelected: this.location.stationId,
                                location: {
                                    id: this.location.stationId,
                                    name: this.location.name,
                                },
                                locationName: this.location.name,
                            })
                            .subscribe();

                        this.reservation.current.location = [id];
                        this.loadingSelectBranch = false;
                        this.store.dispatch(
                            saveVehicles({ value: locations.data }),
                        );
                        this.router.navigate(
                            [
                                this.url.format(
                                    'reservations/cars-and-categories',
                                ),
                            ],
                            {
                                state: {
                                    international: true,
                                },
                            },
                        );
                    });
            });
    }
}
